export default __webpack_public_path__ + "static/media/MSS.5da2afc3.png";